// removed by extract-text-webpack-plugin
module.exports = {"root":"styles__root___2JkEf"};


//////////////////
// WEBPACK FOOTER
// ./src/scenes/ConsumptionProfile/components/Loader/styles.css
// module id = 2922
// module chunks = 0